import {
  FieldTypeFactory,
  ComponentTypeFactory,
} from '@sentecacommerce-theme/base'
import { BannerProps } from './banner.props'

export const BannerFields: BannerProps = {
  images: FieldTypeFactory.list({
    label: 'Banners',
    of: {
      image: FieldTypeFactory.image(),
      imageWidth: FieldTypeFactory.number(),
      imageHeight: FieldTypeFactory.number(),
      mobileImage: FieldTypeFactory.image({ required: false }),
      mobileImageWidth: FieldTypeFactory.number({ required: false }),
      mobileImageHeight: FieldTypeFactory.number({ required: false }),
      header: FieldTypeFactory.text({ required: false }),
      url: FieldTypeFactory.text(),

      expiry: {
        validFrom: FieldTypeFactory.number({ required: false }),
        validTo: FieldTypeFactory.number({ required: false }),
      },
    },
  }),
  default: {
    alt: FieldTypeFactory.text(),
    ariaLabel: FieldTypeFactory.text(),
  },
}

export const BannerType = ComponentTypeFactory.create<BannerProps>(
  'Banner',
  BannerFields
)
